const state = {
  isMobile: navigator.userAgent.indexOf('Mobile') !== -1,
  activeMenu: '0-0',
  mobileMenuVisible: false,
  stopBack: false, // 是否要阻止返回
  stopWindowShow: false, // 阻止返回的弹窗是否显示
}

const getters = {
  getIsMobile: state => { return state.isMobile },
  getActiveMenu: state => { return state.activeMenu },
  getMobileMenuVisible: state => { return state.mobileMenuVisible },
  stopBack: state => { return state.stopBack },
  stopWindowShow: state => { return state.stopWindowShow },
}

const mutations = {
  setIsMobile: (state, value) => {
    state.isMobile = !!value
  },
  setActiveMenu: (state, value) => {
    state.activeMenu = value
  },
  setMobileMenuVisible: (state, value) => {
    state.mobileMenuVisible = value
  },
  setStopBack: (state, value) => {
    state.stopBack = value
  },
  setStopWindowShow: (state, value) => {
    state.stopWindowShow = value
  },
}

const actions = {
  setIsMobile: ({ commit }, value) => {
    return new Promise((resolve) => {
      commit('setIsMobile', value)
      resolve()
    })
  },
  setActiveMenu: ({ commit }, value) => {
    return new Promise((resolve) => {
      commit('setActiveMenu', value)
      resolve()
    })
  },
  setMobileMenuVisible: ({ commit }, value) => {
    return new Promise((resolve) => {
      commit('setMobileMenuVisible', value)
      resolve()
    })
  },
  setStopBack: ({ commit }, value) => {
    commit('setStopBack', value)
  },
  setStopWindowShow: ({ commit }, value) => {
    commit('setStopWindowShow', value)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
